import type { PersonalAccessToken } from '../../../types/PersonalAccessToken';
import { get, post, remove } from '../request';

const BASE = '/api/v2/personal-access-token';

getTokens.operation = 'READ';
getTokens.updateOnCreate = (args: any, x: any, xs: any) => [x, ...xs];
export function getTokens() {
    return get(BASE);
}

// this contains the revealed token - we do NOT want to cache it!
createToken.operation = 'NO_OPERATION';
export function createToken(token: string) {
    return post<PersonalAccessToken>(BASE, { postData: { token } });
}

// pass the dto you received in createToken to this to store it - without the token itself
storeToken.operation = 'CREATE';
export function storeToken(token: Exclude<PersonalAccessToken, 'id'>) {
    return Promise.resolve({ ...token, token: null });
}

revokeToken.operation = 'DELETE';
export function revokeToken(tokenId: string) {
    return remove(`${BASE}/${tokenId}`);
}

revokeAllTokens.invalidates = ['getTokens'];
export function revokeAllTokens() {
    return remove(BASE);
}
